import Icon from "@client/controls/Icon/component";
import { Loading } from "@client/controls/Loading/component";
import { type Common } from "@client/types";
import UploadDndFile, { type UploadDndFileChildrenArgs } from "@common/controls/Upload/DndFile";
import { useI18n } from "@common/hooks/i18n";
import classNames from "classnames";
import * as React from "react";

export type MediaUploaderProps = {
  className?: string;

  portalId: string;

  onUploaded: (media: Common.Media) => void;
};

export default (props: MediaUploaderProps) => {
  const i18n = useI18n();

  return (
    <UploadDndFile
      type="Image"
      url={`/api/site/v1/modules/leaderboard/profilePicture?portalId=${props.portalId}`}
      onUploaded={props.onUploaded}
    >
      {(args: UploadDndFileChildrenArgs) => (
        <div className={classNames("wsc_file_uploader", props.className, { no_preview: true })} {...args.rootProps}>
          <div className="dropzone dz-clickable" tabIndex={0}>
            <div className="dz-default dz-message">
              <input {...args.inputProps} />

              {args.isUploading ? <Loading /> : <Icon iconClassName="far fa-file-download" />}

              <span>
                {args.isUploading
                  ? `${args.progress}% uploaded`
                  : i18n.dropToUpload || "Drop file here or click to upload"}
              </span>
            </div>
          </div>
        </div>
      )}
    </UploadDndFile>
  );
};
